<div class="container-address-confirmation">
  <p class="h3">{{ 'modalAddressConfirmation.confirmYourShippingAddress' | cxTranslate }}</p>

  <address-card [card]="{ address: this.data.address, card: {} }"></address-card>

  <div class="actions">
    <button type="button" class="btn btn-outline-primary" (click)="cancel()">{{ 'modalAddressConfirmation.cancel' | cxTranslate }}</button>

    <button type="button" class="btn btn-primary" (click)="next()">{{ 'modalAddressConfirmation.confirm' | cxTranslate }}</button>
  </div>
</div>